import { Menu } from '@/components/Menu';
import { Loader } from '@/components/Loader';
import { Notifications } from '@/components/Notifications';
import { Login } from '@/pages/Login';
import { Suspense } from 'react';
import './App.scss';
import { useApp } from './useApp';
import { useRouter } from './useRouter';

function App() {
    const { auth } = useApp();
    const { router } = useRouter();

    return (
        <div>
            {auth ? (
                <div>
                    <Menu/>
                    <Suspense fallback={<Loader/>}>
                        {router}
                    </Suspense>
                </div>
            ) : <Login/>}
            <Notifications/>
        </div>
    );
}

export default App;
